export { default as ko } from './ko.json';
export { default as en } from './en.json';
